// extracted by mini-css-extract-plugin
export var gif = "_le-0";